// extracted by mini-css-extract-plugin
module.exports = {"title":"Main_title__Ti3rH","text":"Main_text__3TW-z","containerMobile":"Main_containerMobile__hlxLt"};